import {
  Box,
  Button,
  Flex,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  useDisclosure,
  Text,
  Divider,
  ModalCloseButton,
} from '@chakra-ui/react'

import success from 'Assets/Common/success.png'
import failure from 'Assets/Common/error.png'

import { useState } from 'react'

interface IPaymentModal extends React.ComponentPropsWithRef<'div'> {
  mode: string
  title: string
}

export const PaymentModal = (props: IPaymentModal) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { isOpen: isSecondOpen, onOpen: onSecondOpen, onClose: onSecondClose } = useDisclosure()
  return (
    <>
      <Box margin='10'>
        {props.mode === 'success' && (
          <>
            <Button onClick={onOpen}>Click on Payment Success Modal</Button>
            <Modal isOpen={isOpen} onClose={onClose}>
              <ModalContent rounded='lg'>
                <Flex direction='column' alignItems='center'>
                  <Box>
                    <Image src={success} width='80px' height='80px' marginTop='12px' />
                  </Box>
                  <Box>
                    <ModalHeader textAlign='center'>{props.title}</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody marginX='2'>
                      <Text textAlign='center' fontSize='16px'>
                        We have shared your policy details on your registered email id.
                      </Text>
                      <Flex direction='column'>
                        <Flex justifyContent='space-between'>
                          <Text fontSize='18px' fontWeight='bold'>
                            Payment type
                          </Text>
                          <Text>Net banking</Text>
                        </Flex>
                        <Flex justifyContent='space-between'>
                          <Text fontSize='18px' fontWeight='bold'>
                            Bank
                          </Text>
                          <Text>HDFC</Text>
                        </Flex>
                        <Flex justifyContent='space-between'>
                          <Text fontSize='18px' fontWeight='bold'>
                            Mobile
                          </Text>
                          <Text>9888114057</Text>
                        </Flex>
                        <Flex justifyContent='space-between'>
                          <Text fontSize='18px' fontWeight='bold'>
                            Email
                          </Text>
                          <Text>email@gmail.com</Text>
                        </Flex>
                        <Box marginY='4'>
                          <Divider />
                        </Box>
                        <Flex justifyContent='space-between'>
                          <Text fontSize='18px' fontWeight='bold'>
                            Amount paid
                          </Text>
                          <Text>500.00</Text>
                        </Flex>
                        <Flex justifyContent='space-between'>
                          <Text fontSize='18px' fontWeight='bold'>
                            Transaction Id
                          </Text>
                          <Text>122323997</Text>
                        </Flex>
                        <Flex justifyContent='space-between'>
                          <Text fontSize='18px' fontWeight='bold'>
                            Quotation Number
                          </Text>
                          <Text>122323997</Text>
                        </Flex>
                      </Flex>
                      <Flex w='full' gap='6' marginY='2'>
                        <Button variant='outline' color='primary' w='full' rounded='full'>
                          Close
                        </Button>
                        <Button
                          variant='solid'
                          backgroundColor='primary'
                          w='full'
                          color='white'
                          rounded='full'
                        >
                          View Policy Status
                        </Button>
                      </Flex>
                    </ModalBody>
                  </Box>
                </Flex>
              </ModalContent>
            </Modal>
          </>
        )}
      </Box>
      <Box margin='10'>
        {props.mode === 'failure' && (
          <>
            <Button onClick={onSecondOpen}>Click on Payment Failure Modal</Button>
            <Modal isOpen={isSecondOpen} onClose={onSecondClose}>
              <ModalContent rounded='lg'>
                <Flex direction='column' alignItems='center'>
                  <Box>
                    <Image src={failure} width='80px' height='80px' marginTop='12px' />
                  </Box>
                  <Box>
                    <ModalHeader textAlign='center'>{props.title}</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                      <Text textAlign='center' marginX='10' marginY='1'>
                        Any money deducted contact <br />
                        <Text fontWeight='semibold'>helpline number or email</Text>
                        <Text>In case not deducted retry the payment</Text>
                      </Text>
                      <Flex w='full' gap='6' marginY='4'>
                        <Button variant='outline' color='primary' w='full' rounded='full'>
                          Close
                        </Button>
                        <Button
                          variant='solid'
                          backgroundColor='primary'
                          w='full'
                          color='white'
                          rounded='full'
                        >
                          Retry
                        </Button>
                      </Flex>
                    </ModalBody>
                  </Box>
                </Flex>
              </ModalContent>
            </Modal>
          </>
        )}
      </Box>
    </>
  )
}
